import React, { useState, useEffect } from "react";
import { Dropdown, Header } from "semantic-ui-react";
import "../selectorEERR/selectorEERR.scss";
import { GetEOAFStructure } from "src/graphql/eoaf";
import { EOAF_TRANSLATE } from "src/utils/enum";

const OCULT_TEXT = 'Ocultar del Estado de Resultados'

export default function SelectorEOAF({
  style = {},
  onChange = () => { },
  onBlur = () => { },
  id = "defaultEERRArea",
  name = "defaultEERRArea",
  className = "",
  placeholder = "Área de EOAF",
  defaultValue = "",
  multiple = false,
  clearable = true,
  value = "",
  companyId = "",
  controlled = true,
}) {
  const [search, setSearch] = useState("")

  useEffect(() => {
    if (companyId) reexecuteQuery({ companyId })
  }, [companyId])

  if (!companyId) return <Dropdown
    selectOnBlur={false}
    noResultsMessage="No se encontraron áreas"
  />

  const { data, reexecuteQuery } = GetEOAFStructure({ companyId })
  const eoaf = data?.getEOAFStructure

  if (!eoaf) return <Dropdown
    selectOnBlur={false}
    noResultsMessage="No se encontraron áreas"
  />

  const list = [];

  Object.keys(eoaf.report).forEach((el) => {
    if (el !== "__typename") {
      list.push({
        name: el,
        text: EOAF_TRANSLATE[el],
        disabled: true,
        className: "headerDropdownPepper",
        content: (
          <Header
            style={{
              fontSize: "1em",
              color: "#0099ff",
              fontWeight: 700,
              textTransform: "uppercase",
            }}
            content={EOAF_TRANSLATE[el]}
            size="small"
          />
        ),
      });
      eoaf.report[el].forEach((subEERR) => {
        list.push({
          id: subEERR.fieldKey,
          key: subEERR.fieldKey,
          name: subEERR.field,
          value: subEERR.fieldKey,
          text: subEERR.field,
          content: subEERR.field,
          disabled: false,
          category: subEERR.category,
          categoryKey: subEERR.categoryKey,
          type: el,
        });
      });
    }
  })

  const searchingFunction = (_, s) => {
    setSearch(s?.searchQuery)
  }

  if (controlled) { //  CONTROLADO

    const selected = list.find(f => f.value == value)
    const text = !value ? null : value == 'none' ? OCULT_TEXT : selected?.text || null

    return (
      <Dropdown
        selectOnBlur={false}
        text={text}
        placeholder={placeholder}
        multiple={multiple}
        value={value}
        onSearchChange={searchingFunction}
        search
        selection
        fluid
      >
        <Dropdown.Menu className="dropdownEERR">
          <Dropdown.Item key='none' value='none' id='none' name='none' text={OCULT_TEXT} icon="hide" onClick={onChange} />
          <Dropdown.Divider style={{ margin: 0 }} />
          <Dropdown.Menu scrolling onBlur={onBlur} noResultsMessage="El área no existe">
            {list.filter((f) => f?.text?.toLowerCase()?.includes(search.toLowerCase())).map((option) => (
              <Dropdown.Item {...option} onClick={onChange} />
            ))}
          </Dropdown.Menu>
        </Dropdown.Menu>
      </Dropdown>
    )
  } else { //NO CONTROLADO
    return (
      <Dropdown
        selectOnBlur={false}
        className={className}
        multiple={multiple}
        style={{ ...style }}
        placeholder={placeholder}
        id={id}
        name={name}
        options={list}
        onBlur={onBlur}
        clearable={clearable}
        onChange={onChange}
        defaultValue={defaultValue}
        selection
        search
        fluid
        noResultsMessage="El área no existe"
      />
    );
  }
}
